import React, {PropsWithChildren} from "react";

type ToggleSwitchProps = {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  customClass?: string;
  disabled?: boolean;
};

const ToggleSwitch: React.FC<PropsWithChildren<ToggleSwitchProps>> = ({
  children,
  checked = false,
  onChange,
  customClass = "",
  disabled = false,
}) => {
  return (
    <label
      className={[
        "toggle-switch",
        customClass,
        checked ? "toggle-switch--checked" : "",
        disabled ? "toggle-switch--disabled" : "",
      ].join(" ")}
    >
      <div className="toggle-switch__slide">
        <input
          type="checkbox"
          role="switch"
          checked={checked}
          onChange={(evt) => {
            if (onChange) {
              onChange(evt.target.checked);
            }
          }}
          disabled={disabled}
        />
        <i className={`toggle-switch__dot icon-${checked ? "check" : "close"}--white`} />
      </div>
      <div className="toggle-switch__label">{children}</div>
    </label>
  );
};

export default ToggleSwitch;
